import React from 'react';
import { useRouteByName } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import { ScreenRedirect } from '@atlassian/jira-screen-redirect/src/ui/ScreenRedirect.tsx';
import { generatePath, useRouter } from '@atlassian/react-resource-router';

export const DashboardRedirect = () => {
	const [
		{
			query,
			location: { hash },
		},
	] = useRouter();
	const { path } = useRouteByName('dashboard-view') ?? {};
	if (path == null) {
		throw new Error('Dashboard view route not found');
	}

	const { selectPageId: id } = query;

	const idParam = /^\d+$/.test(id) ? id : 'last-visited';
	const generatedPath = generatePath(path, { dashboardId: idParam });

	const maximizedId = hash.match(/.*\/(?<id>\d+)/)?.groups?.id ?? null;
	const pathWithQuery =
		maximizedId !== null ? `${generatedPath}?maximized=${maximizedId}` : generatedPath;

	return <ScreenRedirect to={pathWithQuery} persistSearchParams={false} />;
};
